import { createMuiTheme } from '@material-ui/core/styles';

export const fetchTheme = themeName => {
    switch ( themeName ) {
        case "grey":
            return greyTheme;
        case "white":
            return whiteTheme;
        default:
            return formTheme;
    }
};

export const WhiteFormOption = {
    root: {
        color: "#ffffff",
    },
    inputLabel: {
        color: "#ffffff !important",
    },
    inputBase: {
        color: "#ffffff !important",
    },
    input: {
        color: "#ffffff !important",
        "&:before": {
            borderBottom: "1px solid rgba(255, 255, 255, 0.42) !important"
        },
        "&:after": {
            borderBottom: "2px solid rgb(255, 255, 255) !important"
        }
    },
    iconButton:{
        color: "#ffffff !important",
    }
};

export const whiteTheme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            root: {
                width: "100%",
                marginBottom: "0.6rem"
            }
        },
        MuiTypography: {
            root: {
                fontSize: "inherit"
            },
            body1: {
                fontFamily: "inherit !important",
                fontSize: "inherit !important",
                letterSpacing: "inherit !important"
            },
            body2: {
                fontSize: "inherit",
                color: "inherit"
            }
        },
        MuiInputLabel: {
            root: {
                color: "#ffffff",
            },
        },
        MuiFormLabel: {
            root: {
                color: "#ffffff",
            },
        },
        MuiIconButton: {
            root: {
                color: "#ffffff"
            }
        },
        MuiInput: {
            input: {
                height: '100%',
                '&:not($disabled)': {
                    color: "#ffffff",
                    letterSpacing: "normal"
                }
            },
            underline: {
                marginBottom: "1px",
                color: "#ffffff",
                '&$disabled': {
                    '&:before': {
                        border: "none",
                    }
                },
                '&:hover': {
                    '&:not($disabled)': {
                        '&:not($focused)': {
                            '&:not($error)': {
                                '&:before': {
                                    borderBottom: "2px solid rgba(255, 255, 255, 0.42)"
                                }
                            }
                        }
                    }
                },
                '&:not($disabled)': {
                    '&:before': {
                        borderBottom: "1px solid rgba(255, 255, 255, 0.42)"
                    },
                    '&:hover:before': {
                        borderBottom: "1px solid rgba(255, 255, 255, 0.42)"
                    }
                },
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: "-10px",
                marginRight: "0",
                marginBottom: '0'
            }
        }
    },
    typography: {
        useNextVariants: true,
        fontFamily: "Rajdhani, Arial, Helvetica, sans-serif",
        fontSize: 18
    },
    palette: {
        primary: {
            main: "#ffffff"
        }
    },
});

export const formTheme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            root: {
                width: "100%",
                marginBottom: "0.6rem"
            }
        },
        MuiTypography: {
            root: {
                fontSize: "inherit"
            },
            body1: {
                fontFamily: "inherit !important",
                fontSize: "inherit !important",
                letterSpacing: "inherit !important"
            },
            body2: {
                fontSize: "inherit",
                color: "inherit"
            }
        },
        MuiInputLabel: {
            root: {
                color: "#000000",
            },
        },
        MuiFormLabel: {
            root: {
                color: "#000000",
            },
        },
        MuiIconButton: {
            root: {
                color: "#000000"
            }
        },
        MuiInput: {
            input: {
                height: '100%',
                '&:not($disabled)': {
                    //color: "#000000",
                    letterSpacing: "normal"
                }
            },
            underline: {
                marginBottom: "1px",
                '&$disabled': {
                    '&:before': {
                        border: "none",
                    }
                },
                '&:hover': {
                    '&:not($disabled)': {
                        '&:not($focused)': {
                            '&:not($error)': {
                                '&:before': {
                                    borderBottom: "2px solid rgba(0, 0, 0, 0.42)"
                                }
                            }
                        }
                    }
                },
                '&:not($disabled)': {
                    '&:before': {
                        borderBottom: "1px solid rgba(0, 0, 0, 0.42)"
                    },
                    '&:hover:before': {
                        borderBottom: "1px solid rgba(0, 0, 0, 0.42)"
                    }
                },
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: "-10px",
                marginRight: "0",
                marginBottom: '0'
            }
        }
    },
    typography: {
        useNextVariants: true,
        fontFamily: "Rajdhani, Arial, Helvetica, sans-serif",
        fontSize: 18
    },
    palette: {
        primary: {
            main: "#000000",
        }
    },
});

export const greyTheme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            root: {
                width: "100%"
            }
        },
        MuiInputLabel: {
            root: {
                color: "#919191"
            }
        },
        MuiIconButton: {
            root: {
                color: "#919191"
            }
        },
        MuiInput: {
            input: {
                color: "#919191",
                letterSpacing: "normal"
            },
            underline: {
                marginBottom: "1px",
                '&:($disabled)': {
                    display: "none"
                },
                '&:hover': {
                    '&:not($disabled)': {
                        '&:not($focused)': {
                            '&:not($error)': {
                                '&:before': {
                                    borderBottom: "2px solid rgba(0, 0, 0, 0.42)"
                                }
                            }
                        }
                    }
                },
                '&:hover:before': {
                    borderBottom: "1px solid rgba(0, 0, 0, 0.42)"
                },
                '&:before': {
                    borderBottom: "1px solid rgba(0, 0, 0, 0.42)"
                }
            }
        }
    },
    typography: {
        useNextVariants: true,
        fontFamily: "Rajdhani, Arial, Helvetica, sans-serif",
        fontSize: 18
    },
    palette: {
        primary: {
            main: "#919191",
        }
    },
});